import React, { useState } from "react";
import { Drawer, Box, Typography, IconButton, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { GapActionRow, useGapResolution, sortPendingFirst, pendingCountOf } from "./gapResolution";

// Packaging ficha — two tabs like the other entity fichas. Packaging is a leaf (no trace endpoint),
// so its "Trazabilidad" is WHERE IT'S USED: the articles that reference this packaging. Gaps come
// pre-loaded (pivoted from groupBy=article); articles too. Actions resolve every underlying gap.
const useStyles = makeStyles((theme) => ({
  drawer: { width: "50vw", minWidth: 560, maxWidth: 900 },
  tabs: { display: "flex", gap: 8, padding: "0 16px 8px" },
  body: { padding: theme.spacing(0, 2, 3) },
  sub: { fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: "0.05em", color: theme.palette.text.secondary, margin: "6px 0" },
  useRow: { fontSize: 13, padding: "4px 0", borderBottom: `1px solid ${theme.palette.divider}` },
  empty: { color: "#94a3b8", padding: theme.spacing(1, 0) },
}));
const muted = { color: "#94a3b8" };

const PackagingTracePanel = ({ api, packagingId, packagingName, gaps = [], articles = [], contracted, initialTab = "pendientes", onClose, onChanged }) => {
  const classes = useStyles();
  const [tab, setTab] = useState(initialTab);
  const { rows, busyId, provide, assume, reject } = useGapResolution(api, gaps, packagingId, onChanged);

  const sortedGaps = sortPendingFirst(rows);
  const pendingCount = pendingCountOf(rows);

  return (
    <Drawer anchor="right" open onClose={onClose} classes={{ paper: classes.drawer }}>
      <Box p={2} pb={1} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" style={{ lineHeight: 1.2 }}>{packagingName || "Packaging"}</Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box className={classes.tabs}>
        <Button size="small" variant={tab === "pendientes" ? "contained" : "outlined"} color="primary" onClick={() => setTab("pendientes")}>
          Pendientes{pendingCount ? ` (${pendingCount})` : ""}
        </Button>
        <Button size="small" variant={tab === "trace" ? "contained" : "outlined"} color="primary" onClick={() => setTab("trace")}>
          Trazabilidad
        </Button>
      </Box>

      <Box className={classes.body}>
        {tab === "pendientes" &&
          (sortedGaps.length === 0 ? (
            <div className={classes.empty}>Sin pendientes en este packaging.</div>
          ) : (
            sortedGaps.map((g) => (
              <GapActionRow
                key={g.id}
                gap={g}
                contracted={contracted}
                busy={busyId === g.id}
                onProvide={provide}
                onAssume={assume}
                onReject={reject}
              />
            ))
          ))}

        {tab === "trace" && (
          <>
            <div className={classes.sub}>Dónde se usa ({articles.length} artículo{articles.length === 1 ? "" : "s"})</div>
            {articles.length ? (
              articles.map((a) => (
                <div key={a.id} className={classes.useRow}>
                  {a.name}
                </div>
              ))
            ) : (
              <span style={muted}>No se usa en ningún artículo</span>
            )}
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default PackagingTracePanel;
